

function reportColumns(handleSendPdf,handleSendEmail) {
  return [
    {
      Header: "Customer",
      accessor: "customer_name",
      disableFilters: true,
      filterable: true,
    },
    {
      Header: "Phone",
      accessor: "phone",
      disableFilters: true,
      filterable: true,
    },
    {
      Header: "Qty",
      accessor: "total_qty",
      disableFilters: true,
      filterable: true,
      Cell: ({ value }) => <>{value ? value.toFixed(2) : 0}</>,
    },
    {
      Header: "Total Debit",
      accessor: "total_debit",
      disableFilters: true,
      filterable: true,
      Cell: ({ value }) => <>{value ? value.toFixed(2) : 0}</>,
    },
    {
      Header: "Total Credit",
      accessor: "total_credit",
      disableFilters: true,
      filterable: true,
      Cell: ({ value }) => <>{value ? value.toFixed(2) : 0}</>,
    },
    {
      Header: "Total Closing Balance",
      accessor: "closing_balance",
      disableFilters: true,
      filterable: true,
      Cell: ({ value }) => <>{value ? value.toFixed(2) : 0}</>,
    },
    {
      Header: "Total Orders",
      accessor: "orders",
      disableFilters: true,
      filterable: true,
      Cell: ({ value }) => (
        <span className={`badge ${value ? "bg-success" : "bg-warning"}`}>
          {value ? Object.entries(value).length : 0}
        </span>
      ),
    },
    {
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      Cell: ({ row }) => (
        <div className="d-flex">
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleSendPdf(row.original)}
        >
          Send PDF
        </button>
        <button
            className="btn btn-sm btn-success d-flex align-items-center mx-2"
            onClick={() => handleSendEmail(row.original)}
            title="Send Email"
          >
            <i className="mdi mdi-email me-2 "></i>
            <span>Email</span>
          </button>
        </div>
      ),
    },
  ];
}
export default reportColumns;
